module.exports = __webpack_public_path__ + "img/cofing_materiales.ac25231f.png";